import { PromoPageKeys } from '../pages/PromoPage/types'

export const getPromoModuleKey = (key: string) => `${PromoPageKeys.promoModule}.${key}`
